import React, { useState } from "react"
import ContainerBox from "../components/ui/containerBox"
import Calendar from "../components/ui/calendar"
import "../index.css"
import { useSelector } from "react-redux"
import localStorageService from "../services/localStorage.service"
import RecordsList from "../components/home/recordsList"
import { useNavigate } from "react-router-dom"
import dictionary from "../utils/dictionary"
import { useDispatch } from "react-redux"
import { setDate } from "../store/dateSlice"
import brownTriangle from "../assets/imgs/brownTriangle.png"
import CrmRecordsLoadingShell from "../components/ui/crmRecordsLoadingShell"
import { useClientRecords } from "../hooks/useApiQueries"

const ClientMainPage = () => {
  const selectedLanguage = useSelector((state) => state.lang.lang)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [calendarDate, setCalendarDate] = useState(new Date())
  const firstDay = new Date(calendarDate)
  const clientId = localStorageService.getClientId()
  if (!clientId) {
    navigate("/client/login")
  }

  let date = useSelector((state) => state.date.date).split(".")
  date = `${date[2]}-${Number(date[1]) > 9 ? date[1] : "0" + Number(date[1])}-${
    Number(date[0]) > 9 ? date[0] : "0" + Number(date[0])
  }`

  const { data: records, isPending } = useClientRecords(clientId, date)

  const handleDateSelect = async (selected) => {
    setCalendarDate(new Date(selected.year, selected.month - 1, selected.day))
    const dateStore = `${selected.day}.${selected.month}.${selected.year}`
    await dispatch(setDate(dateStore))
  }

  const handleSetDate = async (nextDate) => {
    setCalendarDate(nextDate)
    const dateStore = `${nextDate.getDate()}.${
      nextDate.getMonth() + 1
    }.${nextDate.getFullYear()}`
    await dispatch(setDate(dateStore))
  }

  if (isPending && records == null) {
    return (
      <CrmRecordsLoadingShell
        selectedLanguage={selectedLanguage}
        firstDay={firstDay}
        handleSetDate={handleSetDate}
        handleDateSelect={handleDateSelect}
      />
    )
  }

  return (
    <div className="container-fluid relative mx-auto h-[calc(100vh-252px)] flex justify-center items-start bg-cream">
      <ContainerBox>
        <h2 className="text-brown text-2xl max-md:text-lg">
          {dictionary[selectedLanguage].serviceList}
        </h2>
        <div className="flex items-center">
          <img
            className="-rotate-90 w-[12px] h-[15px]"
            src={brownTriangle}
            alt=""
            onClick={() =>
              handleSetDate(new Date(firstDay.getTime() - 1000 * 60 * 60 * 24))
            }
          />
          <Calendar
            date={new Date(firstDay.getTime())}
            handleSelectDate={handleDateSelect}
          />
          <img
            className="rotate-90 w-[12px] h-[15px]"
            src={brownTriangle}
            alt=""
            onClick={() =>
              handleSetDate(new Date(firstDay.getTime() + 1000 * 60 * 60 * 24))
            }
          />
        </div>

        {isPending ? (
          <p className="text-gray text-sm py-4">…</p>
        ) : (
          <RecordsList filteredRecords={records} pageType={"client"} />
        )}
      </ContainerBox>
    </div>
  )
}

export default ClientMainPage
